import { AxisLabelsLayerSpecification } from '../chart-props';
import { getAxisRect } from '../helpers';
import { VectorDrawFunction } from './type';

export const drawAxisLabelsLayer: VectorDrawFunction<AxisLabelsLayerSpecification> = (
    pass,
    features,
    layer,
    xAxis,
    yAxis,
    featureState
) => {
    // TODO: other axes
    if (layer.layout.axis === 'x') {
        let lastX = 0;
        const rect = getAxisRect(layer.layout.position ?? xAxis.getProps().position, pass);

        for (let i = 0; i < features.length; i++) {
            const feature = features[i];
            const state = feature.id ? featureState?.[feature.id] : undefined;
            if (layer.filter && !layer.filter(feature, i)) {
                continue;
            }

            if (feature.geometry.type !== 'Point') {
                continue;
            }

            const x = xAxis.project(feature.geometry.coordinates[0], pass.viewState) + 5;
            const y = pass.viewState.chartViewport.bottom + 10;
            if (!layer.layout.allowOverlap) {
                if (x - lastX < 15) {
                    continue;
                }
            }
            if (!rect.contains(x, y)) {
                continue;
            }

            const color = typeof layer.paint.textColor === 'function' ? layer.paint.textColor(feature, state) : layer.paint.textColor;
            const text = typeof layer.layout.getText === 'function' ? layer.layout.getText(feature, state) : layer.layout.getText;
            const font = pass.getFont(
                typeof layer.layout.fontSize === 'function' ? layer.layout.fontSize(feature, state) : layer.layout.fontSize
            );

            //if (xAxis.getProps().position === ChartPosition.top) {
            //
            //} else {
            pass.drawer.drawText(
                text.length > 5 ? text.substring(0, 5) + '...' : text,
                [x, y],
                {
                    alignment: 'end',
                    baseline: 'bottom',
                    font
                },
                {
                    color: color
                },
                -45
            );

            lastX = x;
            // }
        }
    } else {
        //
    }
};
